/* globals gon */

import { supportedLocales } from '../config'
import { redirect } from '../utils'

const COUNTRY_BY_IP_LOCALE_TO_ISO = {
  iw: 'he',
  ji: 'yi',
  in: 'id',
  'en-UK': 'en-GB',
  'en-US': 'en'
}

const LocaleService = {
  LOCAL_STORAGE_KEY: 'locale',

  autoSwitchToLocale(locale) {
    if (this.hasUrlLocale() || this._isLocaleRedirectDisabled()) return

    this.switchToLocale(locale)
  },

  // TODO: remove this test purpose only code
  _isLocaleRedirectDisabled() {
    return window.gon.disableLocaleRedirect != null
  },

  switchToLocale(locale) {
    locale = this.normalize(locale)
    if (this._canSwitchToLocale(locale)) this._redirectToLocale(locale)
  },

  _canSwitchToLocale(locale) {
    return this._isSupported(locale) && locale !== this.getPageLocale()
  },

  _isSupported(locale) {
    return supportedLocales.indexOf(locale) !== -1
  },

  normalize(locale) {
    if (locale != null) {
      locale = locale.replace('_', '-')
      if (COUNTRY_BY_IP_LOCALE_TO_ISO[locale] != null) {
        locale = COUNTRY_BY_IP_LOCALE_TO_ISO[locale]
      }
    }
    if (!this._isSupported(locale)) {
      locale = locale.split('-')[0]
    }
    return locale
  },

  _redirectToLocale(locale) {
    const currentPath = window.location.pathname + window.location.search
    const newPath = this.getRedirectPath(locale, this.getUrlLocale(), currentPath)
    redirect(newPath, { replace: true })
  },

  getRedirectPath(locale, urlLocale, currentPath) {
    const localeRegExp = new RegExp(`^/${urlLocale}`)

    if (localeRegExp.test(currentPath)) {
      return currentPath.replace(localeRegExp, `/${locale}`)
    } else {
      // there is no locale in the current path
      return `/${locale}${currentPath}`
    }
  },

  getPageLocale() {
    return gon.locale
  },

  hasUrlLocale() {
    const urlLocale = this.getUrlLocale()
    return urlLocale != null && urlLocale.length
  },

  getUrlLocale() {
    return gon.urlLocale
  },

  localizePath(url) {
    const locale = `/${this.getPageLocale()}`
    if (/^\//.test(url)) {
      return locale + url
    } else {
      return `${locale}/${url}`
    }
  }
}

export default LocaleService
